import Icon from './Icon';

const TABS = [
  { id: 'today', label: 'My Day', icon: 'today' },
  { id: 'leads', label: 'Leads', icon: 'leads' },
  { id: 'logvisit', label: 'Log Touchpoint', icon: 'logvisit', fab: true },
  { id: 'visits', label: 'Customer Call', icon: 'visits' },
  { id: 'map', label: 'Map', icon: 'map' },
];

export default function BottomNav({ view, onNavigate, onLogVisit }) {
  const handle = (id) => {
    if (id === 'logvisit') return onLogVisit();
    onNavigate(id);
  };
  return (
    <nav className="botnav" role="navigation" aria-label="Primary">
      {TABS.map((t) => (
        <button
          key={t.id}
          className={`tab${t.fab ? ' fab' : ''}${view === t.id ? ' active' : ''}`}
          onClick={() => handle(t.id)}
          aria-label={t.label}
        >
          {t.fab ? <span className="fab-circle"><Icon name={t.icon} size={20} /></span> : <Icon name={t.icon} size={20} />}
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
